import Cat from "../img/Cat.jpg";
import Validate from "../img/Validate.png";
import WishYouWereBeer from "../img/WishYouWereBeer.png";
import SuperGalacticAgeCalculator from "../img/SuperGalacticAgeCalculator.png";
import NoMoreCoverLetter from "../img/NoMoreCoverLetter.png";
import Pizzaria from "../img/Pizzaria.png";
import Valor from "../img/Valor.png";
import CForCityCouncil from "../img/CForCityCouncil.png";
import BTeamCards from "../img/BTeamCards.png";
import WhenIsDndNext from "../img/WhenIsDndNext.png";

export const PROJECTS = [
  {
    name: "When is DnD Next?",
    techStack: [
      {
        lang: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        lang: "CSS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        lang: "Vite",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg",
      },
      {
        lang: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
      },
      {
        lang: "HTML",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
      },
      {
        lang: "Firestore",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
      },
    ],
    description:
      "A shared scheduling tool built for a friend group to keep track of upcoming Dungeons & Dragons sessions, with real-time updates powered by Firestore.",
    link: "https://www.whenisdndnext.com/",
    repo: "https://github.com/JesseDWhite/when-is-dnd-next",
    image: WhenIsDndNext,
  },
  {
    name: "C For City Council",
    techStack: [
      {
        lang: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        lang: "CSS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        lang: "Vite",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg",
      },
      {
        lang: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
      },
      {
        lang: "HTML",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
      },
    ],
    description:
      "A full campaign website built for a local city council candidate, featuring HubSpot integration for voter outreach and lead capture. The candidate won their election.",
    link: "https://www.cforcitycouncil.com/",
    repo: "https://github.com/JesseDWhite/c_for_council",
    image: CForCityCouncil,
  },
  {
    name: "B-Team Cards",
    techStack: [
      {
        lang: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        lang: "CSS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        lang: "Vite",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vitejs/vitejs-original.svg",
      },
      {
        lang: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
      },
    ],
    description:
      "A private family website for collecting and displaying holiday cards received each year, creating a lasting digital archive of seasonal memories.",
    link: "https://www.bteamcards.com/",
    repo: "https://github.com/JesseDWhite/bteam_cards",
    image: BTeamCards,
  },
  {
    name: "No More Cover Letter",
    techStack: [
      {
        lang: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        lang: "CSS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        lang: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
      },
      {
        lang: "HTML",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
      },
      {
        lang: "Node.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg",
      },
      {
        lang: "Firebase",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
      },
      {
        lang: "Firestore",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
      },
      {
        lang: "Python",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg",
      },
    ],
    description:
      "A keyword-matching tool that scores cover letters against job postings to help applicants stand out. Currently used by Epicodus Coding Bootcamp's career services department to support student job placement.",
    link: "https://nomorecoverletter.com/",
    repo: "https://github.com/JesseDWhite/Job-Tracker",
    image: NoMoreCoverLetter,
  },
  {
    name: "Super Galactic Age Calculator",
    techStack: [
      {
        lang: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        lang: "CSS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        lang: "HTML",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
      },
      {
        lang: "Bootstrap",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/bootstrap/bootstrap-original.svg",
      },
    ],
    description:
      "Enter your name and age to discover how old you'd be on other planets, along with how your age compares to that planet's average life expectancy.",
    link: "https://nostalgic-joliot-c01fcb.netlify.app/",
    repo: "https://github.com/JesseDWhite/super-galactic-age-calculator",
    image: SuperGalacticAgeCalculator,
  },
  {
    name: "Cheesus Crust Pizzeria",
    techStack: [
      {
        lang: "JavaScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        lang: "CSS",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        lang: "HTML",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
      },
      {
        lang: "Bootstrap",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/bootstrap/bootstrap-original.svg",
      },
    ],
    description:
      "An online ordering app for a fictional pizza restaurant where users customize their order and receive a calculated total based on their selections.",
    link: "https://jessedwhite.github.io/pizza-parlor/",
    repo: "https://github.com/JesseDWhite/pizza-parlor",
    image: Pizzaria,
  },
];
